export default __webpack_public_path__ + "static/media/unicef-logo.74673d40.png";